import React, { useState } from "react";

import Modal from "../../../components/dialogs/modal";

import { LifvsUser } from "../../../models/User";
import { NotificationMessage } from "../../../models/Notification";
import * as UserApi from "../../../api/users";
import { TextField } from "@material-ui/core";
import { useI18n } from "../../../hooks/useI18n";

import useStyles from "./styles";

interface FormValues {
  [index: string]: string;
  title: string;
  body: string;
  route: string;
}

export interface SendNotificationModalProps {
  readonly user: LifvsUser;
  readonly visible: boolean;
  readonly onCloseDialog: () => void;
}

export const SendNotificationModal = ({
  user,
  visible,
  onCloseDialog
}: SendNotificationModalProps) => {
  const { t } = useI18n();

  const errorMessages: { [index: string]: string } = {
    title: t("common.pleaseInputTitleForNotification"),
    body: t("common.pleaseInputBodyForNotification")
  };

  const validate = (values: FormValues) => {
    const errors: { [index: string]: string } = {};
    const requiredFields = Object.keys(errorMessages);

    requiredFields.forEach(field => {
      if (!values[field]) {
        errors[field] = errorMessages[field];
      }
    });

    return errors;
  };

  const [formValues, setFormValues] = useState<FormValues>({
    title: "",
    body: "",
    route: ""
  });

  const [errors, setErrors] = useState<{ [index: string]: string }>({});

  const styles = useStyles();

  const isValid = (validationResult: { [index: string]: string }) =>
    Object.keys(validationResult).length === 0;

  const onSend = () => {
    const validationResult = validate(formValues);

    if (isValid(validationResult)) {
      let msg: NotificationMessage = {
        title: formValues?.title ?? "",
        body: formValues?.body ?? "",
        route: formValues?.route ?? ""
      };

      UserApi.notify(user.id, msg).then(onCloseDialog);
    } else {
      setErrors(validationResult);
    }
  };

  return (
    <Modal
      open={visible}
      title={t("common.sendNotificationToUser")}
      actions={[
        {
          text: t("common.send"),
          type: "ok",
          action: onSend
        },
        {
          text: t("common.actions.cancel"),
          type: "cancel",
          action: onCloseDialog
        }
      ]}
    >
      <form className={styles.formContainer}>
        <TextField
          label={`${t("common.title")} (${user.deviceLanguage})`}
          placeholder={`${t("common.title")} (${user.deviceLanguage})`}
          error={errors["title"] !== undefined}
          helperText={errors["title"] !== undefined && errorMessages["title"]}
          value={formValues?.title}
          onChange={({ target: { value } }) =>
            setFormValues({ ...formValues, title: value })
          }
        />
        <TextField
          label={`${t("common.body")} (${user.deviceLanguage})`}
          placeholder={`${t("common.body")} (${user.deviceLanguage})`}
          error={errors["body"] !== undefined}
          helperText={errors["body"] !== undefined && errorMessages["body"]}
          value={formValues?.body}
          onChange={({ target: { value } }) =>
            setFormValues({ ...formValues, body: value })
          }
        />
        <TextField
          label={t("common.route")}
          placeholder={t("common.route")}
          value={formValues?.route}
          onChange={({ target: { value } }) =>
            setFormValues({ ...formValues, route: value })
          }
        />
      </form>
    </Modal>
  );
};
